import React from 'react';
import Modal from 'react-modal';
import Button from '../../../../Forms/Button';

import './CancelPlanConfirm.scss';

interface ConfirmCancelPlanModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
    onConfirm: () => void;
}

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
Modal.setAppElement('#root');

function ConfirmCancelPlanModal({ 
    isOpen, 
    onRequestClose, 
    onConfirm 
}: ConfirmCancelPlanModalProps) {

    return (
        <Modal
            isOpen={isOpen}
            style={customStyles}
            onRequestClose={onRequestClose}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            contentLabel="Cancelar Subscripción"
        >
            <div id="cancelPlanModal">
                <h4>¿Seguro que desea cancelar su plan?</h4>
                <div className='contentText'>
                    <p>
                        Al cancelar el plan, todas las cuentas conectadas de FiscalPOP que requieran subscripción serán desactivadas y no podrás generar CFDIs hasta que tengas un plan activo nuevamente. 
                    </p>
                    <p>
                        Si contaba con un saldo positivo, este se mantendrá en tu cuenta y aquellas plataformas que pueden usar solo saldo para facturar se mantendrán activas.
                    </p>
                    <p>
                        Estos cambios se aplicarán inmediatamente al cancelar tu plan, por lo que te recomendamos revisar tu cuenta y plataformas conectadas para evitar interrupciones en tu facturación.   
                    </p>
                </div>
                <div className="buttonRow">
                    <Button primary handleClick={onConfirm}>
                        <span>
                            Cancelar mi plan
                        </span>

                    </Button>
                    <Button tertiary handleClick={onRequestClose}>
                        <span>
                            No, mantener mi plan
                        </span>
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ConfirmCancelPlanModal;